// brands
export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_BRANDS_FAILURE = 'GET_BRANDS_FAILURE';
export const GET_BRANDS_REQUEST = 'GET_BRANDS_REQUEST';
export const CLEAR_BRANDS = 'CLEAR_BRANDS';

// brand
export const SELECT_BRAND = 'SELECT_BRAND';
export const CLEAR_SELECTED_BRAND = 'CLEAR_SELECTED_BRAND';

// pagination
export const SET_BRANDS_SEARCH = 'SET_BRANDS_SEARCH';
export const SET_BRANDS_PAGE_SIZE = 'SET_BRANDS_PAGE_SIZE';
export const NEXT_BRANDS_PAGE = 'NEXT_BRANDS_PAGE';
export const PREV_BRANDS_PAGE = 'PREV_BRANDS_PAGE';
